const DownIcon = ({ height = "7", width = "12", viewBox = "0 0 12 7", className = "hayley-h-6 hayley-w-6 hayley-text-secondary" }) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" className={className}>
      <path d="M11 1L6 6L1 1" stroke="#333333" strokeOpacity="0.75" strokeMiterlimit="10" strokeLinecap="square" />
    </svg>
  );
};

export default DownIcon;
